import { esgDocumentService } from "@/services/api/esgDocument.service";
import { esgDocumentModel } from "@/models/api/esgDocument.model";
import { sharedHelper } from "@/utils";

export const ESG_DOCUMENT_MODULE = "api/esgDocument";
export const GET_ALL_ESG_DOCUMENT = "getAllEsgDocument";

export const state = {
  list: {
    data: [],
    pagination: {
      pageNumber: 1,
      pageSize: 15,
      lastPage: 1,
      total: 0,
      tableRowsCounts: 0,
    },
  },
  status: { list: true },
  listError: false,
  requestId: 0,
};

export const actions = {
  async [GET_ALL_ESG_DOCUMENT]({ commit, state }, { filter }) {
    commit("requesting");
    const requestId = state.requestId;
    try {
      const result = await esgDocumentService.getAll(filter);
      if (!result?.success || !Array.isArray(result.data)) {
        throw new Error("ESG document request failed.");
      }
      if (requestId === state.requestId) commit("listSuccess", result);
      return result;
    } catch (error) {
      if (requestId === state.requestId) commit("failure");
      return null;
    }
  },
};

export const mutations = {
  requesting(state) {
    state.requestId++;
    state.status.list = false;
    state.listError = false;
  },
  listSuccess(state, result) {
    state.list.data = result.data.map(esgDocumentModel);
    state.list.pagination = result.pagination
      ? sharedHelper.apiPaginationAdapter(result.pagination)
      : {
          pageNumber: 1,
          pageSize: 15,
          lastPage: 1,
          total: result.data.length,
          tableRowsCounts: result.data.length,
        };
    state.status.list = true;
  },
  failure(state) {
    state.listError = true;
    state.status.list = true;
  },
};
